import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const A4PrinterPaperPage = () => (
  <ProductDetail product={products.a4PrinterPaper} />
);

export default A4PrinterPaperPage;
